import $ from 'jquery';

const stickyDirective = [
  '$window',
  $window => ({
    restrict: 'A',
    scope: {
      tctStickyContainer: '@',
      tctStickyTop: '<?',
    },
    link: (scope, element) => {
      const $container = scope.tctStickyContainer
        ? document.querySelector(scope.tctStickyContainer)
        : $window;

      const $jContainer = $($container);
      const $jElement = $(element);
      const scrollTop = scope.tctStickyTop
        ? scope.tctStickyTop
        : 0;

      function handleScrolling() {
        if ($jContainer.scrollTop() >= scrollTop) {
          $jElement.addClass('tct-sticky--sticky');
        } else {
          $jElement.removeClass('tct-sticky--sticky');
        }
      }

      $container.addEventListener('scroll', handleScrolling);
      $jElement.addClass('tct-sticky');

      scope.$on('$destroy', () => {
        $container.removeEventListener('scroll', handleScrolling);
      });
    },
  }),
];

export default stickyDirective;
